/*
 * @Author: cgh
 * @Date: 2022-08-01 10:50:50
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-30 16:28:49
 * @Description: 评估项目管理
 */

const pgxmRoutes = {
  path: 'pgxm',
  name: 'jxxfPgxm',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'jxxfPgxmManage',
      component: () => import(/* webpackChunkName: "pgxmManageList" */ '@/features/jxxf/pg/pgxm/list.vue'),
      meta: {
        navtabTitle: '评估项目管理',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false,
        menuElements: [
          { elementCode: 'jxxf_pg_project_search', elementName: '查询' },
          { elementCode: 'jxxf_pg_report_reevaluate', elementName: '重新评估' },
          { elementCode: 'jxxf_pg_project_edit', elementName: '申请修改' }
        ]
      }
    },
    {
      path: 'add',
      name: 'jxxfPgxmAdd',
      component: () => import(/* webpackChunkName: "pgxmAdd" */'@/features/jxxf/pg/pgxm/add.vue'),
      meta: {
        navtabTitle: '添加评估项目',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'edit/:id',
      name: 'jxxfPgxmEdit',
      // component: () => import(/* webpackChunkName: "pgxmEdit" */'@/features/jxxf/pg/pgxm/addOrUpdateDialog.vue'),
      component: () => import(/* webpackChunkName: "pgxmEdit" */'@/features/jxxf/pg/pgxm/details/edit.vue'),
      meta: {
        navtabTitle: '修改评估项目',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'detail/:id',
      name: 'jxxfPgxmDetail',
      component: () => import(/* webpackChunkName: "pgxmDetail" */'@/features/jxxf/pg/pgxm/details/view.vue'),
      meta: {
        navtabTitle: '查看评估项目',
        isCache: true,
        ignoreDiff: ['showType'],
        menuElements: []
      }
    }
  ]
};

export default pgxmRoutes;
